import dayjs from 'utils/customDayJS';
import { browserTimeZone } from 'constants/timeConstants';

export const formatDateAsTimeBrowserTimezone = date => {
	return dayjs(date).tz(browserTimeZone);
};

export const getTimeZoneAbbreviation = timeZone => {
	return dayjs().tz(timeZone).format('z');
};
